// MlOAuthCallback — /admin/canales/ml/callback
// Página de aterrizaje del OAuth flow de MercadoLibre.
// Recibe ?code=XXX&state=YYY → llama edge function ml-oauth-callback → redirige a /configuracion.

import { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { supabase } from '../../lib/supabase'

export default function MlOAuthCallback() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [estado, setEstado] = useState('procesando')  // procesando | ok | err
  const [mensaje, setMensaje] = useState('Validando autorización con MercadoLibre…')

  useEffect(() => {
    const code = params.get('code')
    const state = params.get('state')
    const errorMl = params.get('error')

    if (errorMl) {
      setEstado('err')
      setMensaje(`ML devolvió error: ${errorMl} ${params.get('error_description') || ''}`)
      return
    }

    if (!code) {
      setEstado('err')
      setMensaje('Falta el parámetro `code` en la URL. ¿Llegaste acá desde el botón Conectar?')
      return
    }

    // Validar state (anti-CSRF)
    const expectedState = sessionStorage.getItem('ml_oauth_state')
    if (expectedState && state !== expectedState) {
      setEstado('err')
      setMensaje('State no coincide. Posible intento de hijack. Cancelado.')
      return
    }
    sessionStorage.removeItem('ml_oauth_state')

    // Canjear code por tokens via edge function
    supabase.functions.invoke('ml-oauth-callback', {
      body: {
        code,
        state,
        redirect_uri: window.location.origin + '/admin/canales/ml/callback',
      },
    }).then(({ data, error }) => {
      if (error || data?.error) {
        setEstado('err')
        setMensaje('Error canjeando code: ' + (error?.message || data?.error || 'desconocido'))
        return
      }
      setEstado('ok')
      setMensaje(`Conectado como @${data.nickname}. Redirigiendo en 2 segundos…`)
      setTimeout(() => navigate('/admin/canales/mercadolibre/configuracion'), 2000)
    }).catch(e => {
      setEstado('err')
      setMensaje('Excepción: ' + (e?.message || String(e)))
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div style={{
      minHeight: '100vh',
      background: '#F8F6F1',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Inter, sans-serif',
      padding: 20,
    }}>
      <div style={{
        background: 'white',
        border: '1px solid #E6E2D8',
        borderRadius: 12,
        padding: 36,
        maxWidth: 480,
        textAlign: 'center',
      }}>
        <div style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: estado === 'ok' ? '#E1F5EE' : estado === 'err' ? '#FDEEEE' : '#E0F4F6',
          color: estado === 'ok' ? '#085041' : estado === 'err' ? '#791F1F' : '#00A8B5',
          margin: '0 auto 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 28,
        }}>
          {estado === 'ok' ? '✓' : estado === 'err' ? '✕' : '⋯'}
        </div>
        <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1A3461', margin: '0 0 8px' }}>
          {estado === 'ok' ? 'Conectado a MercadoLibre' : estado === 'err' ? 'Error en conexión' : 'Procesando…'}
        </h2>
        <p style={{ fontSize: 13, color: '#5F5E5A', margin: '0 0 18px', lineHeight: 1.5 }}>
          {mensaje}
        </p>
        {estado === 'err' && (
          <button
            onClick={() => navigate('/admin/canales/mercadolibre/configuracion')}
            style={{
              background: '#00A8B5',
              color: 'white',
              border: 0,
              padding: '9px 18px',
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Volver a configuración
          </button>
        )}
      </div>
    </div>
  )
}
